import g from "./globals";
import cookies from "./cookies";

let lastModified;
let offset;
let tokens;

// TODO: Reinicializar módulo ¿desde globals?
let today = new Date();

try {
  // La fecha de la etiqueta meta necesita seguir el formato iso8601
  // (original) 2013-06-12@11:15:59 +0200
  // (iso8601)  2013-06-12T11:15:59+0200
  let months;
  let strdate = document.querySelector("meta[http-equiv=last-modified]").getAttribute("content");

  tokens = strdate.split(" ");
  if (tokens[4] === "CET" || tokens[4] === "GMT") {
    months = {
      Jan: "01",
      Feb: "02",
      Nov: "11",
      Dec: "12",
    };
    strdate = `${tokens[5]}-${months[tokens[1]]}-${tokens[2]}T${tokens[3]} +0000`;
  } else if (tokens[4] === "CEST") {
    months = {
      Jun: "06",
      Jul: "07",
      Aug: "08",
    };
    strdate = `${tokens[5]}-${months[tokens[1]]}-${tokens[2]}T${tokens[3]} +0100`;
  } else {
    strdate = strdate.replace("@", "T").replace(" ", "");
  }
  lastModified = Date.parse(strdate);
} catch (e) {
  lastModified = today;
}

const A_DAY = 24 * 60 * 60 * 1000;

if (offset === Number(cookies.read("mktTimeTravelOffset"))) {
  const result = A_DAY * offset;
  today = new Date(Number(today) + result);
  lastModified = new Date(Number(lastModified) + result);

  document.querySelector("body").append(`\
<div style="position: fixed;top: 0px;z-index: 9999;width: 99%;padding: 5px;text-align:center;">
  <span style="margin:0 auto;">TimeTravel: ${lastModified}</span>
<div>\
`);
}

const api = {
  toDate(dateStr, addOffset) {
    if (addOffset == null) {
      addOffset = false;
    }
    if (typeof dateStr !== "string") {
      return dateStr;
    }
    // TODO: Ojo el offset de españa varia de invierno a verano
    const IE_OFFSET = 0;
    offset = addOffset ? this.today.getTimezoneOffset() / -60 : IE_OFFSET;
    const sign = offset < 0 ? "-" : "+";
    offset = Math.abs(offset);
    let offsetHours = Math.floor(offset);
    let offsetMinutes = (offset - offsetHours) * 60;
    if (offsetHours < 10) {
      offsetHours = `0${offsetHours}`;
    }
    if (offsetMinutes < 10) {
      offsetMinutes = `0${offsetMinutes}`;
    }
    const isoDate = `${dateStr}:00${sign}${offsetHours}:${offsetMinutes}`.replace(" ", "T");
    return Date.parse(isoDate);
  },
  today,
  lastModified,
  // # TODO: cambiar valores por defecto
  // # after: (dateStr, timeFromServer=false, local=false) ->
  // #   after dateStr                -> compara contra today
  // #   after dateStr, server        -> compara contra la lastModified
  // #   after dateStr, server, local -> compara contra la lastModified
  // #   #=> returns false si el dateStr no es válido
  // after: (dateStr, local=true) ->
  //   @toDate(dateStr, local) < lastModified
  // before: (dateStr, local=true) ->
  //   lastModified < @toDate(dateStr, local)
  // between: (startDateStr, endDateStr, local=true) ->
  //   @after(startDateStr, local) and @before(endDateStr, local)
  format(strdate) {
    if (!/\d\d\/\d\d\/20\d\d/.test(strdate)) {
      return strdate;
    }
    const format = g.shortDateFormat;
    tokens = strdate.split("/");
    const dict = {
      d: tokens[0],
      m: tokens[1],
      Y: tokens[2],
    };
    return format.replace(/%[admY]/g, t => dict[t[1]]);
  },
  between(startsAt, endsAt, options) {
    // En países dónde hay múltiples husos horarios
    if (options == null) {
      options = {};
    }
    if (options.client == null) {
      options.client = true;
    }
    if (options.addOffset == null) {
      options.addOffset = true;
    }
    if (!endsAt && !startsAt) {
      throw new Error("startsAt or endsAt is mandatory");
    }
    if (!endsAt) {
      endsAt = "2999-01-01 00:00";
    }
    if (!startsAt) {
      startsAt = "2010-01-01 00:00";
    }
    const now = options.client ? this.today : lastModified;
    startsAt = this.toDate(startsAt, options.addOffset);
    endsAt = this.toDate(endsAt, options.addOffset);
    return startsAt < now && now < endsAt;
  },
};

export default api;
window.__mkt_time = api;
